/** Replace the calendar day atomically to avoid overflowing a shorter month. */
export const changeReminderDate = (value: string, date: Date): string => {
    const current = new Date(value)
    current.setFullYear(date.getFullYear(), date.getMonth(), date.getDate())
    return current.toISOString()
}

export const changeReminderTime = (value: string, date: Date): string => {
    const current = new Date(value)
    current.setHours(date.getHours(), date.getMinutes(), 0, 0)
    return current.toISOString()
}
